import { Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import { EllipsisContainer } from 'src/components/EllipsisContainer/EllipsisContainer';
import {
    MainContainer,
    MainEntityListItemText,
    MasterDetailsAsideItem,
} from 'src/components/MasterDetailsPage/MasterDetailsAsideItem';
import { EntityLinks } from 'src/core/router/EntityLinks';
import { Campaign } from 'src/generated-api-client';
import { ProductStatus } from 'src/pages/ProductsPage/ProductStatus';

type CampaignsListItemProps = { campaign: Campaign };

export const CampaignsListItem = observer(
    ({ campaign }: CampaignsListItemProps) => {
        return (
            <MasterDetailsAsideItem
                to={EntityLinks.campaigns.itemDetails(campaign.id)}
            >
                <MainContainer>
                    <Tooltip title={campaign.name}>
                        <EllipsisContainer>
                            <MainEntityListItemText
                                className="strong-text"
                                data-testid="name"
                            >
                                {campaign.name}
                            </MainEntityListItemText>
                        </EllipsisContainer>
                    </Tooltip>
                    <ProductStatus item={campaign} />
                </MainContainer>
            </MasterDetailsAsideItem>
        );
    },
);
